// extracted by mini-css-extract-plugin
export default {"container":"bH-z","innerContainer":"cH-z","multipleLines":"dH-z","heading":"eH-z","content":"fH-z","linkColor":"gH-z"};